import React, { useRef, useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveFilter,
  setSearchField,
  userSignIn,
  userSignOut,
  setFilteredContent,
  setNotifications,
  setUnseenNotifCount,
  setSocketConnection,
  setFilteredVideos,
} from "../../../redux/actions";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import CardMembershipOutlined from "@material-ui/icons/CardMembershipOutlined";
import Videocam from "@material-ui/icons/Videocam";
import YoutubeSearchedForIcon from "@material-ui/icons/YoutubeSearchedFor";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import Badge from "@material-ui/core/Badge";
import logo from "../../../img/logo.png";
import "../universal.css";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import Sign from "../../Authentication/GetIn/Sign";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import SideBar from "./DeskSideBar/SideBar";
import { ALL, POSTS, VIDEOS, QNAS, POLLS } from "../../../redux/constants";
import { removeProfile } from "../../../redux/actions/index";
import { GroupOutlined, HomeOutlined, LiveHelp, Home, Group } from "@material-ui/icons";
import { fetchAllContent } from "../../../redux/dataFetchers/contentApi";
import { subscribePushNotifications } from "../../../redux/dataFetchers/serviceWorkerApis";
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  option: {
    fontSize: "0.7rem",
    padding: "0.3rem",
    margin: "0.5rem",
    borderRadius: "1.9em",
    color: "gray",
    backgroundColor: "white",
    "&:hover": {
      color: "#B0343C",
    },
  },
  activeOption: {
    color: "#B0343C",
  },
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  link: {
    textDecoration: "none",
  },
  notif: {
    padding: theme.spacing(2),
    border: "2px solid #B0343C",
    borderRadius: "5px",
    margin: "0.1rem 0.3rem",
    boxShadow: "2px 2px 3px 1px solid #757575",
  },
  customBadge: {
    backgroundColor: "#B0343C",
    color: "white",
  },
  tooltip: {
    fontSize: "0.8em",
  },
}));

const TopHeader = () => {
  const classes = useStyles();
  const inputRef = useRef(null);
  const [homeStyle, setHomeStyle] = useState("#B0343C");
  const [comStyle, setComStyle] = useState("");
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [state, setState] = useState({
    left: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const reduxState = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();

  //custom variables
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    reduxState.info.socket &&
      reduxState.info.socket.on("connect", () => {
        console.log(
          `socket connection opened with server id ${reduxState.info.socket.id}`
        );
      });

    //when scheduled notification has arrived
    if (reduxState.info.info.uid) {
      //console.log(reduxState.info.socket);
      let socket = reduxState.info.socket;
      socket &&
        socket.off("notifArrived") &&
        socket.on("notifArrived", (newNotification) => {
          console.log("newnotification", newNotification);
          //Replace recipients array content with only current user if it's a recipient
          let recipient = newNotification.recipients.find((recipient) => {
            console.log(reduxState.info.info);
            return recipient.user === reduxState.info.info.uid;
          });

          console.log(recipient);
          //If current user is a recipient
          if (recipient && recipient.user) {
            newNotification.recipients = [recipient];
            dispatch(
              setNotifications([
                newNotification,
                ...reduxState.info.notifications,
              ])
            );
            !open &&
              dispatch(
                setUnseenNotifCount(reduxState.info.unseenNotifCount + 1)
              );
          }
        });
    }
  }, [
    reduxState.info.info,
    reduxState.info.unseenNotifCount,
    reduxState.info.notifications,
  ]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const askPushNotifPermission = (reg) => {
    return Notification.requestPermission()
      .then(function (permissionResult) {
        if (permissionResult !== "granted") {
          throw new Error("We weren't granted permission.");
        }
        console.log("Asked for permission", permissionResult);
        //subscibe user for sending push notifications
        subscribePushNotifications(reg, null, reduxState.info.info.uid);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeNotifs = () => {
    setAnchorEl(null);
    if (!reduxState.authUser.isAuthenticated) return;

    //Update notification state and mark seen
    const seenNotifications = reduxState.info.notifications.map(
      (notification) => {
        notification.recipients[0].seen = true;
        return notification;
      }
    );
    dispatch(setNotifications(seenNotifications));
  };

  const configurePushNotifService = () => {
    if (!("serviceWorker" in window.navigator)) {
      // Service Worker isn't supported on this browser, disable or hide UI.
      return;
    }

    if (!("PushManager" in window)) {
      // Push isn't supported on this browser, disable or hide UI.
      return;
    }

    navigator.serviceWorker.ready.then((reg) => {
      reg.pushManager.getSubscription().then((sub) => {
        if (sub) {
          //update subsctiption object as it may change
          subscribePushNotifications(reg, sub, reduxState.info.info.uid);
          console.log(sub);
        } else {
          //register user for push notif
          console.log(reg, "Asked");
          askPushNotifPermission(reg);
        }
      });
    });
  };

  const openNotifs = (event) => {
    configurePushNotifService();

    setAnchorEl(event.currentTarget);
    if (!reduxState.authUser.isAuthenticated) return;

    //set only unseen notif count to 0 and update seen status only when notifpanel is closed
    dispatch(setUnseenNotifCount(0));

    //filter unseen notification's ids
    const unseenNotifs = reduxState.info.notifications.reduce(
      (result, notification) => {
        let recipient = notification.recipients.find(
          (recipient) => recipient.user === reduxState.info.info.uid
        );
        console.log(recipient);

        if (recipient && recipient.user && !recipient.seen) {
          result.push(notification._id);
        }
        return result;
      },
      []
    );

    if (!unseenNotifs.length) return;
    //change status of unseen notifs to seen without updating current notification's state
    const token = window.localStorage.getItem("token");
    fetch("https://recruitingmonk-v2.azurewebsites.net/notifications/seen", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        uid: reduxState.info.info.uid,
        unseenNotifIds: unseenNotifs,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          console.log("successfully marked Notifications as seen");
          // setNotifications(response.notifications);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const Logout = () => {
    localStorage.removeItem("token");
    dispatch(userSignOut());
    dispatch(removeProfile({}));
    dispatch(fetchAllContent());
    dispatch(setNotifications([]));
    dispatch(setUnseenNotifCount(0));
    history.push("/");
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem button onClick={() => history.push("")}>
          <CardMembershipOutlined
            style={{ color: "#b32800" }}
            fontSize="small"
          />{" "}
          <ListItemText
            primary="Feed"
            style={{ color: "#b32800", marginLeft: "17%" }}
          />
        </ListItem>
        <ListItem button onClick={() => history.push("/videos")}>
          <Videocam style={{ color: "#b32800" }} fontSize="small" />
          <ListItemText
            primary="Videos"
            style={{ color: "#b32800", marginLeft: "17%" }}
          />
        </ListItem>
        <ListItem
          button
          className={classes.link}
          onClick={() => history.push("/quiz")}
        >
          <ListItemIcon>
            {" "}
            <LiveHelp
              style={{
                color: "#b32800",
              }}
              fontSize="small"
            />{" "}
          </ListItemIcon>
          <ListItemText primary="Quiz" style={{ color: "#b32800" }} />
        </ListItem>
        <ListItem button onClick={() => history.push("/fellowbot")}>
          <ListItemIcon>
            {" "}
            <QuestionAnswerIcon
              style={{
                color: "#b32800"
              }}
              fontSize="small"
            />{" "}
          </ListItemIcon>
          <ListItemText primary="Fellow Bot" style={{ color: "#b32800" }} />
        </ListItem>
        <ListItem button onClick={() => history.push("/sourcingbot")}>
          <YoutubeSearchedForIcon
            style={{ color: "#b32800" }}
            fontSize="small"
          />
          <ListItemText
            primary="Sourcing Bot"
            style={{ color: "#b32800", marginLeft: "17%" }}
          />
        </ListItem>
        {reduxState.authUser.isAuthenticated && (
          <ListItem button onClick={Logout}>
            <ListItemIcon>
              {" "}
              <ExitToAppIcon
                style={{ color: "#b32800" }}
                fontSize="small"
              />{" "}
            </ListItemIcon>
            <ListItemText primary="Logout" style={{ color: "#b32800" }} />
          </ListItem>
        )}
      </List>
      <Divider />
    </div>
  );

  const sideBar = () => {
    return ["left"].map((anchor) => (
      <React.Fragment key={anchor}>
        <Button id="hamburger" onClick={toggleDrawer(anchor, true)}>
          <MenuIcon
            style={{ color: "#b32800", position: "absolute", left: "19px" }}
            fontSize="small"
          />
        </Button>
        <SwipeableDrawer
          anchor={anchor}
          open={state[anchor]}
          onClose={toggleDrawer(anchor, false)}
          onOpen={toggleDrawer(anchor, true)}
        >
          {list(anchor)}
        </SwipeableDrawer>
      </React.Fragment>
    ));
  };

  const logoImg = () => {
    return (
      <div className="logo" onClick={() => history.push("/")}>
        <img src={logo} alt="Logo"></img>
      </div>
    );
  };

  const signin = () => {
    return (
      <div className="signin">
        <Sign />
      </div>
    );
  };

  const btnHome = () => {
    history.push("/");
    setHomeStyle("#B0343C");
    setComStyle("#757575");
  };

  const btnCom = () => {
    history.push("/community");
    setComStyle("#B0343C");
    setHomeStyle("#757575");
  };

  const inputSearchChange = (e) => {
    setOptionsOpen(true);
  };

  const searchContent = (e) => {
    dispatch(setSearchField(inputRef.current.value));
    setOptionsOpen(false);
    let nextFilteredContent = reduxState.allContent.filteredContent,
      searchField = inputRef.current.value;
    switch (reduxState.allContent.activeFilter) {
      case ALL:
        nextFilteredContent = reduxState.allContent.allContent.filter(
          (data) => {
            return (
              data?.content
                ?.toLowerCase()
                ?.includes(searchField.toLowerCase()) ||
              data?.question
                ?.toLowerCase()
                ?.includes(searchField.toLowerCase()) ||
              data?.desc?.toLowerCase()?.includes(searchField.toLowerCase())
            );
          }
        );
        break;
      case POSTS:
        nextFilteredContent = reduxState.allContent.posts.filter((data) => {
          return data?.content
            ?.toLowerCase()
            ?.includes(searchField.toLowerCase());
        });
        break;
      case VIDEOS:
        nextFilteredContent = reduxState.allContent.videos.filter((data) => {
          return data?.content
            ?.toLowerCase()
            ?.includes(searchField.toLowerCase());
        });
        break;
      case QNAS:
        nextFilteredContent = reduxState.allContent.qnas.filter((data) => {
          return (
            data?.question
              ?.toLowerCase()
              ?.includes(searchField.toLowerCase()) ||
            data?.desc?.toLowerCase()?.includes(searchField.toLowerCase())
          );
        });
        break;
      case POLLS:
        nextFilteredContent = reduxState.allContent.polls.filter((data) => {
          return (
            data?.question
              ?.toLowerCase()
              ?.includes(searchField.toLowerCase()) ||
            data?.desc?.toLowerCase()?.includes(searchField.toLowerCase())
          );
        });
        break;
      default:
        nextFilteredContent = reduxState.allContent.allContent;
    }
    dispatch(setFilteredContent(nextFilteredContent));
    if (reduxState.allContent.activeFilter === VIDEOS)
      dispatch(setFilteredVideos(nextFilteredContent));
    inputRef.current.value = "";
  };

  const inputFilterChange = (filter) => {
    dispatch(setActiveFilter(filter));
    setOptionsOpen(false);
  };

  return (
    <div className="TopHead">
      <div className="TopHeader" id="mobTopHeader">
        <div>{sideBar()}</div>
        <div>
          <div className="logo" onClick={() => history.push("/")}>
            <img src={logo} alt="Logo"></img>
          </div>
        </div>
        <div>
          <Sign />
        </div>
      </div>

      <div id="deskTopHeader">
        <div className="subTopHead">
          {/* <SideBar /> */}

          <div className="logo" onClick={() => history.push("/")}>
            <img src={logo} alt="Logo" />
          </div>
          {/* <div className="subTopHead">
            <Button
              className="btnHome"
              style={{ color: `${homeStyle}` }}
              onClick={btnHome}
            >
              Home
            </Button>
            <Button
              className="btnCom"
              onClick={btnCom}
              style={{ color: `${comStyle}` }}
            >
              Community
            </Button>
          </div> */}
        </div>
        <div className="BottomHeader" style={{marginLeft:30}}>
          <form className="myForm" onSubmit={(e) => e.preventDefault()}>
            <input
              type="search"
              onChange={inputSearchChange}
              spellCheck="false"
              placeholder="Search for posts, questions and polls..."
              ref={inputRef}
            />
            <button onClick={searchContent}><SearchIcon style={{color:'white'}} /></button>
          </form>
          {optionsOpen &&
            (history.location.pathname === "/" ||
              history.location.pathname === "/videos") && (
              <div className="search-options">
                {history.location.pathname === "/" && (
                  <Button
                    onClick={() => inputFilterChange(ALL)}
                    variant="outlined"
                    className={clsx(classes.option, {
                      [classes.activeOption]:
                        reduxState.allContent.activeFilter === ALL,
                    })}
                    size="small"
                  >
                    All
                  </Button>
                )}
                {history.location.pathname === "/" && (
                  <Button
                    onClick={() => inputFilterChange(POSTS)}
                    variant="outlined"
                    className={clsx(classes.option, {
                      [classes.activeOption]:
                        reduxState.allContent.activeFilter === POSTS,
                    })}
                    size="small"
                  >
                    Posts
                  </Button>
                )}
                {(history.location.pathname === "/" ||
                  history.location.pathname === "/videos") && (
                  <Button
                    onClick={() => inputFilterChange(VIDEOS)}
                    variant="outlined"
                    className={clsx(classes.option, {
                      [classes.activeOption]:
                        reduxState.allContent.activeFilter === VIDEOS,
                    })}
                    size="small"
                  >
                    Videos
                  </Button>
                )}
                {history.location.pathname === "/" && (
                  <Button
                    onClick={() => inputFilterChange(QNAS)}
                    variant="outlined"
                    className={clsx(classes.option, {
                      [classes.activeOption]:
                        reduxState.allContent.activeFilter === QNAS,
                    })}
                    size="small"
                  >
                    Qna
                  </Button>
                )}
                {history.location.pathname === "/" && (
                  <Button
                    onClick={() => inputFilterChange(POLLS)}
                    variant="outlined"
                    className={clsx(classes.option, {
                      [classes.activeOption]:
                        reduxState.allContent.activeFilter === POLLS,
                    })}
                    size="small"
                  >
                    Polls
                  </Button>
                )}
                <span
                  style={{
                    fontSize: "1.7rem",
                    color: "gray",
                    cursor: "pointer",
                    position: "absolute",
                    right: "3%",
                  }}
                  onClick={() => setOptionsOpen(false)}
                >
                  &times;
                </span>
              </div>
            )}
        </div>
        <div className="menu">
          {reduxState.authUser.isAuthenticated && (
            <Tooltip title="toggle notification panel" classes={{tooltip:classes.tooltip}}>
              <Button onClick={openNotifs} aria-describedby={id}>
                <Badge
                  badgeContent={reduxState.info.unseenNotifCount}
                  classes={{ badge: classes.customBadge }}
                  max={9}
                  overlap="rectangular"
                >
                  <NotificationsIcon
                    style={{ color: open ? "#B0343C" : "#757575" }}
                  />
                </Badge>
              </Button>
            </Tooltip>
          )}
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={closeNotifs}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <div className="notifs">
              <span>
                <CloseIcon
                  style={{
                    color: "#757575",
                    float: "right",
                    cursor: "pointer",
                  }}
                  onClick={closeNotifs}
                />
              </span>
              <div>
                {reduxState.info.notifications.length ? (
                  reduxState.info.notifications.map((notification) => {
                    return (
                      <Typography
                        key={notification._id}
                        variant="subtitle2"
                        gutterBottom
                        className={classes.notif}
                        style={{
                          background: notification.recipients[0].seen
                            ? ""
                            : "rgb(111, 216, 111)",
                        }}
                      >
                        {notification.description}
                      </Typography>
                    );
                  })
                ) : (
                  <Typography
                    gutterBottom
                    variant="h5"
                    style={{
                      padding: "1.5rem",
                      textAlign: "center",
                      color: "#757575",
                    }}
                  >
                    No Notifications
                  </Typography>
                )}
              </div>
            </div>
          </Popover>
          {/* <Tooltip title="Feed" placement="bottom" classes={{tooltip:classes.tooltip}}>
            <CardMembershipOutlined
              style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={() => history.push("")}
            />
          </Tooltip> */}
          <Tooltip title="Home" placement="bottom" classes={{tooltip:classes.tooltip}}>
            <Home
              style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={btnHome}
            />
          </Tooltip>
          <Tooltip title="Community" placement="bottom" classes={{tooltip:classes.tooltip}}>
            <Group
              style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={btnCom}
            />
          </Tooltip> <Tooltip title="Videos" placement="bottom" classes={{tooltip:classes.tooltip}}>
            <Videocam
              style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={() => history.push("/videos")}
            />
          </Tooltip>
          <Tooltip title="Quiz" placement="bottom" classes={{tooltip:classes.tooltip}}>
            <LiveHelp
              style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={() => history.push("/quiz")}
            />
          </Tooltip>
          <Tooltip title="Fellow Bot" placement="bottom" classes={{tooltip:classes.tooltip}}>
            <QuestionAnswerIcon
              style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={() => history.push("/fellowbot")}
            />
          </Tooltip>
        </div>
        {reduxState.authUser.isAuthenticated ? (
          <Tooltip classes={{tooltip:classes.tooltip}} title="Logout" placement="bottom">
            <ExitToAppIcon style={{
                color: "#b32800",
                margin: "0 0.6rem",
                cursor: "pointer",
              }} onClick={Logout} fontSize="small" />
          </Tooltip>
        ) : (
          ""
        )}
        <div className="subTopHead2">
          <Sign />
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
